export * from './tag-input-settings.interface';
